<template>
  <component
    :is="bannerLink ? 'a' : 'div'"
    class="in-grid-content-banner"
    :href="bannerLink"
  >
    <div class="in-grid-content-banner__overlay" />

    <div class="in-grid-content-banner__media">
      <div
        v-if="video"
        class="in-grid-content-banner__video"
      >
        <video-player
          :video="video"
          :video-identifier="`in-grid-content-banner-${video.source.id}`"
        />
      </div>

      <responsive-image
        v-else
        block-class="in-grid-content-banner"
        :image="bannerImage"
        :min-max="minMax"
        :padding="false"
        sizes="100vw"
      />
    </div>

    <p
      class="
        in-grid-content-banner__cta
        text-heading-3xs
        text-heading-xs-desktop
      "
      :href="bannerLink"
      v-text="bannerText"
    />
  </component>
</template>

<script>

/**
 * Vue: In grid content banner (in-grid-content-banner)
 * -----------------------------------------------------------------------------
 * In grid content banner using on collection page.
 *
 * @param {Object} bannerImage - Banner image.
 * @param {String} bannerLink - Banner link.
 * @param {String} bannerText - Banner text.
 * @param {Object} bannerVideo - Banner video.
 * @param {Number} bannerWidth - Banner width.
 *
 */
import ResponsiveImage from '~global/images/responsive-image'
import VideoPlayer from '~async/video-player/video-player'

export default {
  name: 'InGridContentBanner',

  components: {
    ResponsiveImage,
    VideoPlayer,
  },

  props: {
    bannerImage: {
      type: Object,
      default: () => ({}),
    },
    bannerLink: {
      type: String,
      default: '',
    },
    bannerText: {
      type: String,
      default: '',
    },
    bannerVideo: {
      type: Object,
      default: () => ({}),
    },
    bannerWidth: {
      type: Number,
      default: 1,
    },
  },

  computed: {

    /**
     * Compute min-max value.
     * @returns {String}
     */
    minMax() {
      switch (this.bannerWidth) {
        case 2:
          return '500-1200'
        case 4:
          return '500-2000'
        case 1:
        default:
          return '450-1000'
      }
    },

    /**
     * Compute video.
     * @Returns {Object}
     */
    video() {
      if (!this.bannerVideo.id) {
        return null
      }

      return {
        enableAutoplay: true,
        enableLoop: true,
        source: this.bannerVideo,
      }
    },
  },
}
</script>

<style lang="scss">
@import './in-grid-content-banner';
</style>
